var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Directory', _vm._b({
    staticClass: "individuals",
    on: {
      "text-input": function($event) {
        _vm.filterValues.input_text = $event
      },
      "clear-all": _vm.clearAllFilters,
      "clear-filter": _vm.clearFilter,
      "more-click": _vm.fetchNextPage
    }
  }, 'Directory', {
    activeFilters: _vm.activeFilters,
    inputText: _vm.filterValues.input_text,
    isLoading: _vm.isLoading,
    results: _vm.results,
    resultCount: _vm.resultCount,
    unitLabels: _vm.unitLabels
  }, false), [_c('div', {
    staticClass: "individuals__filters-list",
    slot: "filters"
  }, [_vm._l((_vm.filters), function(filter) {
    return _c('CmSelect', {
      key: filter.id,
      staticClass: "individuals__filter individuals__filter--select",
      attrs: {
        "name": filter.id,
        "options": filter.options,
        "null-label": filter.nullLabel,
        "label": filter.label,
        "multiple": filter.multiple,
        "include-search": filter.options.length > 12,
        "value": _vm.filterValues[filter.id],
        "compact": ""
      },
      on: {
        "input": function($event) {
          _vm.filterValues[filter.id] = $event
        }
      }
    })
  }), _vm._v(" "), _c('LocationFilter', {
    staticClass: "individuals__filter individuals__filter--select",
    attrs: {
      "location": _vm.filterValues.location,
      "radius": _vm.filterValues.radius
    },
    on: {
      "location": function($event) {
        _vm.filterValues.location = $event
      },
      "coords": function($event) {
        _vm.filterValues.coords = $event
      },
      "radius": function($event) {
        _vm.filterValues.radius = $event
      }
    },
    model: {
      value: (_vm.filterValues.location),
      callback: function($$v) {
        _vm.filterValues.location = $$v
      },
      expression: "filterValues.location"
    }
  }), _vm._v(" "), _c('Checkbox', {
    staticClass: "individuals__filter individuals__filter--checkbox",
    attrs: {
      "label": "Single"
    },
    model: {
      value: (_vm.filterValues.is_single),
      callback: function($$v) {
        _vm.filterValues.is_single = $$v
      },
      expression: "filterValues.is_single"
    }
  }), _vm._v(" "), _c('Checkbox', {
    staticClass: "individuals__filter individuals__filter--checkbox",
    attrs: {
      "label": "Student"
    },
    model: {
      value: (_vm.filterValues.is_student),
      callback: function($$v) {
        _vm.filterValues.is_student = $$v
      },
      expression: "filterValues.is_student"
    }
  }), _vm._v(" "), _c('Checkbox', {
    staticClass: "individuals__filter individuals__filter--checkbox",
    attrs: {
      "label": "For Hire"
    },
    model: {
      value: (_vm.filterValues.for_hire),
      callback: function($$v) {
        _vm.filterValues.for_hire = $$v
      },
      expression: "filterValues.for_hire"
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "individuals__list"
  }, _vm._l((_vm.results), function(result) {
    return _c('IndividualCard', {
      key: result.id,
      staticClass: "individuals__individual",
      attrs: {
        "person": result
      }
    })
  }))])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a7b3ea4","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/pages/individuals.vue
// module id = null
// module chunks = 